// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".currency-menu[data-v-b9e6c248] .currency-icon{font-size:1.4em;height:auto;margin-right:0;padding-right:.5em;text-align:right;width:2.5em}.currency-icon[data-v-b9e6c248] .spinner{display:flex;height:1.2em;margin:auto;width:1.2em}.error[data-v-b9e6c248]{color:var(--colour-red)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
